//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'login',
  data () {
    return {
      account: '',
      password: '',
      checkLogin:false,
    }
  },
  created(){
    // this.$func.setLocal('token','');
    if(!this.$func.getLocal('token')){
      this.getCode();
    }else{
      // this.checkCid();
      this.checkCid();
    }
  },
  methods:{
     getCode(){
      var local = window.location.href
      this.code = this.getUrlCode().code 
      var appid = 'wx109fd072a29dad94';
      if (this.code == null || this.code === '') {
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
      } else {
        this.login();
      }
    },
    getUrlCode() {
      var url = window.location.href
      var theRequest = new Object()
      if (url.indexOf("?") != -1) {
         var urls = url.split("?")
          var strs = urls[1].split("&")
          for(var i = 0; i < strs.length; i++) {
              theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
          }
      }
      var code = theRequest.code;
      if(code == 'undefined' || code == null || code === ''){
        this.$func.setLocal('channel',parseInt(theRequest.channel));
      }
      return theRequest
    },
    login(){
        this.$api.login({code:this.code,channel:this.$func.getLocal('channel')}).then((res)=>{
          if(res){
            if(res.data.token){
              this.$func.setLocal('token',res.data.token);
              this.$func.setLocal('grade',res.data.grade);
              this.$func.setLocal('node_v1','');
              if(parseInt(res.data.cid) > 0 ){
                this.getAccess();
              }else{
                this.checkLogin = true;
              }
            }
          }
        })  
    },
    checkCid(){
      this.$api.checkCid({}).then((res)=>{
        if(res.code == 2){
          this.checkLogin = true;
          // this.$func.showToast(res.msg);
          return false;
        }else{
          this.getAccess();
        }
      })
    },
    submit(){
        let that = this;
        if (!that.account) {
            that.$func.showToast('请输入账号');
            return false;
        }
        if (!that.password) {
            that.$func.showToast('请输入密码');
            return false;
        }
        that.$api.loginCommunity({
            account: that.account,
            password: that.password,
        }).then((res)=>{
          if(res){
            that.$func.setLocal('grade',res.data.grade);
            that.$func.setLocal('node_v1','');
            that.getAccess();
          }
        });
    },
    getAccess(){
      // if(!this.$func.getLocal('node_v1')){
        this.$api.getAccess({}).then((res)=>{
          if(res.data){
            this.$func.setLocal('node_v1',JSON.stringify(res.data));
            let grade = parseInt(this.$func.getLocal('grade'));
            switch(grade){
              case 1:
                window.location.href = "/#/group";
                break;
              case 2:
                window.location.href = "/#/group";
                break;
              case 7:
                window.location.href = "/#/driver";
                break;
              case 12:
                window.location.href = "/#/user";
                break;
              case 13:
                window.location.href = "/#/work";
                break;
              case 14:
                window.location.href = "/#/curtain";
                break;
              case 17:
                window.location.href = "/#/work";
                break;
              case 18:
                window.location.href = "/#/work";
                break;
              case 19:
                window.location.href = "/#/factory";
                break;
              case 20:
                window.location.href = "/#/factory";
                break;
              case 23:
                window.location.href = "/#/curtain";
                break;
              case 24:
                window.location.href = "/#/curtain";
                break;
              default:
                window.location.href = "/";
                break;
            }
          }
        })
      // }
    },
    out(){
      // this.$func.confirm('确认退出账号？','温馨提示',()=>{
        this.$api.out({}).then((res)=>{
          this.$func.setLocal('node_v1','');
          this.$func.setLocal('grade','');
          this.$router.push({path:'/login'})
        })
      // })
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/login.vue